import { createAppAsyncThunk } from 'reduxTyped'
import { handleError } from 'shared/api/lib/errors/handlers'
import { AgencyApi } from 'shared/api/requests/agency'
import type { AgencySendVerification } from 'shared/api/requests/agency/schemas'

const getRejectValue = (error: unknown) =>
  (error as { response?: unknown } | null)?.response ?? error

export const confirmEmail = createAppAsyncThunk<Record<string, never>, string>(
  'agency/email/confirm',
  async (code, { rejectWithValue }) => {
    try {
      const { data } = await AgencyApi.confirmEmail({
        body: {
          code,
        },
      })

      return data
    } catch (error) {
      handleError(error, (businessError) => {
        businessError.handle()
      })

      return rejectWithValue(getRejectValue(error) as Error)
    }
  },
)

export const sendVerification = createAppAsyncThunk<
  AgencySendVerification,
  { agencyId: number; email: string }
>('agency/email/sendVerification', async ({ agencyId, email }, { rejectWithValue }) => {
  try {
    const { data } = await AgencyApi.sendVerification({
      path: {
        agency_id: agencyId,
      },
      body: {
        email,
      },
    })

    return data
  } catch (error) {
    handleError(error)

    return rejectWithValue(getRejectValue(error) as Error)
  }
})
